module.exports = __webpack_public_path__ + "static/media/29BDOS1.a8c1998a.jpg";